import { http } from "@/core/api/";

const baseApiReport = "/api/report";
const baseApi = "api/tapRequests";

export const resetTapRequestStatusToNew = async (id) => {
  try {
    await http.post(`${baseApi}/${id}/returntonew`);
    return true;
  } catch {
    return false;
  }
};

export const getTapRequestRefundReport = async (params) =>
  await http.get(`${baseApiReport}/taprequest/refund`, { params });

export const getTapRequestDirectPayment = async (params) =>
  await http.get(`${baseApiReport}/taprequest/directpayment`, { params });

export const getTapRequestPurchaseService = async (params) =>
  await http.get(`${baseApiReport}/taprequest/purchaseservice`, { params });

export const getTapRequestReport = async (id) =>
  await http.get(`${baseApiReport}/taprequest/${id}`);

export const createTapRequestCopyToCentralLevelRecommended = (id) =>
  http.post(`${baseApi}/${id}/createTapRequestCopyToCentralLevelRecommended`);

export const changeInLot = async () => await http.get(`${baseApi}/changeinlot`);

export const changeTapRequestToAmendProcess = (id, amendProcessStatus) =>
  http.put(`${baseApi}/${id}/changestatus`, amendProcessStatus);

export const returnToPreviousStatus = (requestId) =>
  http.put(`${baseApi}/returntopreviousstatus/${requestId}`);

export const revertEgress = (requestId, payload) =>
  http.put(`${baseApi}/${requestId}/revertegress`, payload);

export const deleteTapRequest = (requestId) =>
  http.delete(`${baseApi}/${requestId}`);

export const createCopyToNextYear = (academicYearId) =>
  http.put(`${baseApi}/createcopytonextyear/${academicYearId}`);

export const getTapRequestNotification = (requestId) =>
  http.get(`${baseApi}/${requestId}/notification`);

export const updateDirectorName = (requestId, payload) =>
  http.put(`${baseApi}/${requestId}/notification/directorname`, payload);
